import { ArrowRight } from './icons'
import { Reveal } from '../hooks/useReveal'

export const Contact = ({ company }) => (
  <>
    {company.email && (
      <section className="section" id="contact">
        <div className="container">
          <Reveal className="contact">
            <p className="eyebrow">Contact</p>
            <h2 className="contact__title">Get in touch.</h2>
            <p className="lead contact__lead">
              Questions about any of the products, the store or working
              together — send an email and it comes straight to us.
            </p>

            <a className="btn btn--primary" href={`mailto:${company.email}`}>
              {company.email}
              <ArrowRight className="btn__arrow" />
            </a>
          </Reveal>
        </div>
      </section>
    )}

    <footer className="footer">
      <div className="container footer__inner">
        <p>
          &copy; {new Date().getFullYear()} {company.name}
          {company.abn && <> · ABN {company.abn}</>}
        </p>
        <nav className="footer__links" aria-label="Footer">
          <a href="#top">Back to top</a>
        </nav>
      </div>
    </footer>
  </>
)
